var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('layout-header',{staticClass:"header"}),_c('div',{staticClass:"page-content-container"},[_c('router-view',{staticClass:"page-content"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }